module.exports = __webpack_public_path__ + "img/pingtaijieshao.d8dd1fa2.jpg";